<template>
  <div class="component-wrapper d-flex flex-column">
    <div class="text-h6 text-center title-underline mb-5">{{ $t('partners') }}</div>

    <div class="d-flex align-center mb-12">
      <v-btn
        class="align-self-start"
        small
        color="primary"
        :lang="$i18n.locale"
        @click="$router.push({ path: '/superuser/new-museum' })"
      >
        <v-icon left small>mdi-plus</v-icon>
        {{ $t('newPartner') }}
      </v-btn>

      <v-btn
        class="align-self-start ml-3"
        small
        color="primary"
        :lang="$i18n.locale"
        @click="onDisconnectUser"
      >
        <v-icon left small>mdi-account-off</v-icon>
        {{ $t('disconnectUser') }}
      </v-btn>
    </div>
    
    <v-progress-circular
      indeterminate
      color="primary"
      width="3"
      size="55"
      class="mx-auto mt-12"
      v-if="museumsLoader"
    ></v-progress-circular>

    <template v-else>
      <div class="body-1" v-if="!museums.length">
        {{ $t('addFirstMuseum') }}
      </div>

      <v-row>
        <v-col
          xl="3"
          lg="4"
          md="6"
          sm="6"
          cols="12"
          v-for="museum in museums"
          :key="museum.id"
        >
          <MuseumCard :museum="museum" />
        </v-col>
      </v-row>
    </template>

    <v-dialog v-model="disconnectUserDialog" max-width="500px">
      <DisconnectUser @close-disconnect-user-dialog="disconnectUserDialog = false"/>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MuseumCard from "@/views/superUser/MuseumCard";
import DisconnectUser from "../program/DisconnectUser.vue";

export default {
  components: {
    MuseumCard,
    DisconnectUser
  },
  data() {
    return {
      dialog: false,
      disconnectUserDialog: false
    };
  },
  computed: {
    ...mapState({
      museums: (state) => state.superuser.museums,
      museumsLoader: (state) => state.superuser.museumsLoader,
    }),
  },
  async created() {
    try {
      await this.getMuseums();
    } catch (e) {}
  },
  methods: {
    ...mapActions(["getMuseums"]),
    onDisconnectUser() {
      console.log('open disconnect user dialog');
      this.disconnectUserDialog = true;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>